<template>
  <div class="columns is-vcentered is-mobile search-columns">
    <div class="column is-three-quarters is-three-fifths-desktop is-half-widescreen">
      <b-field :label="$t('general.search')" custom-class="is-sr-only" label-for="searchinput-main">
        <b-input id="searchinput-main" :placeholder="$t('search.placeholder')" type="search" icon="search" custom-class="is-size-3 is-size-1-desktop search-input" class="is-size-3 is-size-1-desktop has-text-white" v-model="searchInput" @keyup.enter.native="submit" autofocus> </b-input>
      </b-field>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'MainSearch',
  props: {},
  data() {
    return {
      searchInput: '',
    }
  },
  computed: {
    ...mapGetters({filter: '$_search/filter'}),
  },
  methods: {
    async submit() {
      this.filter.text = this.searchInput

      //this.$router.push({name: 'search-keyword', params: {keyword: this.searchInput}})
      await this.$store.dispatch('$_search/getProducts', this.filter)
      await this.$store.dispatch('$_search/addTag', this.searchInput)
      this.$emit('search-completed')

      if (!this.$route.query || JSON.stringify(this.$route.query) !== JSON.stringify(this.filter)) {
        this.$router.push({name: 'search', query: this.filter})
      } else {
        this.$router.push({name: 'search'})
      }
    },
  },
}
</script>

<style lang="scss">
.search-columns {
  height: 100vh;

  justify-content: center;
  margin: 0;
}

.search-columns .search-input {
  background: none;
  border-color: rgba(255, 255, 255, 0.75);
  border-bottom-width: 0.2em;
  border-right-width: 0;
  border-left-width: 0;
  border-top-width: 0;
  border-radius: 0;
  box-shadow: none !important;
  color: rgba(255, 255, 255, 0.8);
  transition: 200ms all ease-in-out;

  &:focus,
  &:hover {
    color: white;
    border-color: white;
  }

  // & + .icon,
  // &::placeholder {
  //   color: /*rgba(255, 255, 255, 0.8)*/ black !important;
  // }
}
</style>
